class Base64 {
	hexToBase64(value): string {
		return btoa(String.fromCharCode(...value.match(/.{2}/g).map((x) => parseInt(x, 16))));
	}
}

export const base64 = new Base64();
